

















import {mixins} from "vue-class-component";
import {CommonMixin} from "../../shared/services/mixin";
import {Component, Watch} from "vue-property-decorator";
import MillisecondDatePicker from "../../shared/components/MillisecondDatePicker/index.vue";
import StatisticCustomer from "@/modules/dashboard/statisticcustomer/index.vue";
import StatisticEmployee from "@/modules/dashboard/statisticemployee/index.vue";
import StatisticPartner from "@/modules/dashboard/statisticpartner/index.vue";
import StatisticLading from "@/modules/dashboard/statisticlading/index.vue";
import {DashboardParams} from "@/modules/dashboard/params";
import BarChart from "@/modules/dashboard/components/barchart/index.vue";
import {DashboardStore} from "@/modules/dashboard/store";
import ChartLading from "@/modules/dashboard/chartlading/index.vue";
import StatisticRow2 from "@/modules/dashboard/statisticrow2/index.vue";

@Component({
    name: "Dashboard",
    components: {
        StatisticRow2,
        ChartLading,
        BarChart,
        StatisticLading, StatisticPartner, StatisticEmployee, StatisticCustomer, MillisecondDatePicker}
})
export default class extends mixins(CommonMixin) {
    params = new DashboardParams();

    @Watch("params", { immediate: true, deep: true })
    async onchangeParams(val: any) {
        await DashboardStore.getStatisticCustomer(val);
        await DashboardStore.getStatisticRow2(val);
        await DashboardStore.getStatisticLading(val);
        await DashboardStore.getChartLading(val);
    }
}
